import { DialogFooter } from '@fluentui/react';
import { IPDialog, IPPrimaryButton, IPScrollablePane } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';

import { IPDialogType } from 'baseComponents/Dialog/IPDialog';
import { IPScrollbarVisibility } from 'baseComponents/ScrollablePane/IPScrollablePane';
import { useTranslation } from 'react-i18next';

export interface IDialogOkProps {
  onOk: () => void;
  hidden: boolean;
  title: string;
  subText: string;
  optionalJSX?: JSX.Element;
  optionalJSXHeight?: string | number;
  optionalJSXWidth?: string | number;
}

export const DialogOk = (props: IDialogOkProps) => {
  const { t } = useTranslation(['translation']);

  const dialogContentProps = {
    type: IPDialogType.normal,
    title: props.title,
    subText: props.subText,
  };

  return (
    <IPDialog hidden={props.hidden} onDismiss={props.onOk} dialogContentProps={dialogContentProps}>
      {props.optionalJSX && (
        <IPStack>
          <IPStack.Item
            grow
            styles={{
              root: {
                marginTop: 0,
                position: 'relative',
                width: props.optionalJSXWidth,
                height: props.optionalJSXHeight ?? '20vh',
                maxHeight: '80vh',
              },
            }}
          >
            <IPScrollablePane scrollbarVisibility={IPScrollbarVisibility.auto}>{props.optionalJSX}</IPScrollablePane>
          </IPStack.Item>
        </IPStack>
      )}
      <DialogFooter>
        <IPPrimaryButton onClick={props.onOk} text={t('translation:Dialogs.Ok.Ok')} />
      </DialogFooter>
    </IPDialog>
  );
};
